
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindApparent8 as ObiWindApparent8Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-apparent-8.js';
 
 
 

 
 export const ObiWindApparent8 = createComponent({
   react: React,
   tagName: 'obi-wind-apparent-8',
   elementClass: ObiWindApparent8Element,
   events: {
     
   }
  });
 
 